import { PriceItem } from '../prototype/type';
import { QuoteType } from '../quote';
import request from '../request';
import { CreatePriceRequest, CreatePriceResponse } from './type';

export const savePrice = (payload: CreatePriceRequest) => {
  return request<{ result: CreatePriceResponse }>('/api/price/save', payload);
};

export const previewPrice = (payload: CreatePriceRequest) => {
  return request<{ prices: PriceItem[] }>('/api/price/preview', payload);
};

export const getPricesByPrototypeId = (
  prototype_id: string,
  isSourceNeeded: boolean
) => {
  return request<{
    prices: PriceItem[];
    sources: any[];
    quotations: QuoteType[];
  }>('/api/price/list', {
    prototype_id,
    isSourceNeeded,
  });
};

export const getPricesByPrototypeCode = (
  prototype_code: string,
  isSourceNeeded: boolean
) => {
  return request<{ prices: PriceItem[]; sources: any[] }>('/api/price/list', {
    prototype_code,
    isSourceNeeded,
  });
};

export const getPricesByIds = ({
  price_ids,
  isSourceNeeded,
  isPrototypeNeeded,
}: {
  price_ids: string[];
  isSourceNeeded: boolean;
  isPrototypeNeeded?: boolean;
}) => {
  return request<{ prices: PriceItem[]; sources: any[] }>('/api/price/list', {
    price_ids,
    isSourceNeeded,
    isPrototypeNeeded,
  });
};
